<section class="vc-admin-sites-list">
  <app-admin-list-toolbar
    titleKey="ADMIN.SITES.TITLE"
    descriptionKey="ADMIN.IA.SITES.DESCRIPTION"
    [showSearch]="true"
    searchPlaceholderKey="COMMON.SEARCH"
    [searchValue]="searchValue"
    (searchValueChange)="onSearch($event)"
  >
    <button
      toolbar-actions
      pButton
      type="button"
      icon="fas fa-plus"
      class="p-button-sm"
      [label]="'COMMON.ADD' | translate"
      (click)="router.navigate(['/administration', customer_route_param, 'clinics', 'new'])"
    ></button>
  </app-admin-list-toolbar>

  @if (filteredSites.length === 0) {
    <app-admin-state-panel
      mode="empty"
      titleKey="ADMIN.SITES.EMPTY.TITLE"
      descriptionKey="ADMIN.SITES.EMPTY.DESCRIPTION"
    ></app-admin-state-panel>
  } @else {
    <p-table
      [value]="filteredSites"
      styleClass="Table"
      responsiveLayout="scroll"
      [autoLayout]="true"
      [paginator]="true"
      [rows]="20"
      [rowsPerPageOptions]="[20, 40, 100]"
    >
      <ng-template pTemplate="header">
        <tr>
          <th>{{ 'COMMON.NAME' | translate }}</th>
          <th>{{ 'COMMON.ADDRESS' | translate }}</th>
          <th>{{ 'COMMON.EMAIL' | translate }}</th>
          <th>{{ 'COMMON.PHONE' | translate }}</th>
          <th *ngIf="showCurrencyColumn">{{ 'COMMON.CURRENCY' | translate }}</th>
          <th>{{ 'COMMON.ACTIONS' | translate }}</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-site>
        <tr>
          <td>{{ site.name }}</td>
          <td>{{ site.address }}</td>
          <td>{{ site.email }}</td>
          <td>{{ site.phone }}</td>
          <td *ngIf="showCurrencyColumn">{{ site.currency || '' }}</td>

          <td>
            <app-admin-table-actions
              [manageRouterLink]="[
                '/administration',
                customer_route_param,
                'clinics',
                site.id
              ]"
              (delete)="confirmDelete(site)"
            ></app-admin-table-actions>
          </td>
        </tr>
      </ng-template>
    </p-table>
  }
</section>
